"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _context = require("../context");

var _colors = require("./colors");

var _constants = require("./constants");

var _templateObject;

var ProgressBarThreshold = (0, _context.styledWithTheme)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  height: ", "px;\n  width: ", "px;\n  background-color: ", ";\n"])), _constants.PROGRESS_BAR_THRESHOLD_HEIGHT, _constants.PROGRESS_BAR_THRESHOLD_WIDTH, function (_ref) {
  var status = _ref.status,
      theme = _ref.theme;
  return status ? (0, _colors.getForegroundColor)(status, theme.selectors) : theme.selectors.color('neutral50');
});
var _default = ProgressBarThreshold;
exports.default = _default;